module.exports = __webpack_public_path__ + "img/media-add-folder.30944256.svg";